import React, {useEffect, useMemo, useRef, useState} from "react";
import {Alert, Button, Col, Modal, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {
    fetchAdvancedTypes,
    fetchBankAccounts,
    fetchCashRegisters,
    fetchClients,
    fetchPOS,
    fetchProductsONChange,
    fetchSalesGeneralSettings,
    putClient,
} from "../../../../_apis/api";
import EditableTable from "../../../primer/Editable-Table";
import QuickEdit from "../../../primer/QuickEdit";
import {useSelector} from "react-redux";
import {
    filterNaNValue,
    getCurrentUser,
    getDefaultOptionByValue,
    getDOYOptions,
    getGreekCurrencyFormat,
    getInstallationsTypes,
    getModeByInstallation,
    getNumberByInstallation,
    getOptionsByData,
    getPreNumberByInstallation,
    getQuotationsPrintData,
    getSelectedInstallation,
    getSelectedPreNumbers,
    getVatCategoryOptions,
    isEmpty,
    removeDuplicateObjects,
} from "../../../../_helpers/commonFunctions";
import {setSaveEditQuotations} from "../../../../_reducers/activitySlice";
import {
    setEditQuotationNewProduct,
    setEditQuotations,
    setQuotationDiscountObject
} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import {
    fixDocumentTaxesDisplay,
    getLabelByValue,
    getObjectFromArrayOfObjects
} from "../../../../_helpers/helperFunctions";
import TextArea from "../../../common/TextArea";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import {toast} from "react-toastify";
import axios from "axios";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import NewClientModal from "../Clients/new-client-modal";
import {
    getDiscountExclusiveVat,
    getNetValue,
    getNetValueByTotalValue,
    getPriceExclusiveVat,
    getProductFee,
    getProductOtherTax,
    getProductStamp,
    getProductWithholdTax,
    getSalesTaxesData,
    getSalesTotals,
    getTaxes,
    getTotalValue,
    getUnitPrice,
    getVatPercent,
    getVatValue,
    parseNumber
} from "../../../../_helpers/product-sales-calculations";
import {vatCategoryData} from "../../../../_data/mydata/vatCategory";
import BetterCheckBox from "../../../common/BetterCheckBox";
import moment from "moment";
import HourPicker from "../../../primer/HourPicker";
import useTaggedDispatch from "../../../../hooks/useTaggedDispatch";
import "./salesnew.css";
import SalesPrintA5Greek from "../../PrintLayout/sales-print-a5-greek";
import SalesPrintA5English from "../../PrintLayout/sales-print-a5-english";
import SalesPrintA5DoubleGreek from "../../PrintLayout/sales-print-a5-double-greek";
import SalesPrintA5DoubleEnglish from "../../PrintLayout/sales-print-a5-double-english";
import SalesPrintTemplateGreek1 from "../../PrintLayout/sales-print-template1-greek";
import SalesPrintTemplateEnglish1 from "../../PrintLayout/sales-print-template1-english";
import SendEmail from "../../../primer/POPUP-COMPONENTS/Send-Email";
import LogTable from "../../../primer/LogTable";
import getMyData from "../../../../_helpers/sharedmydata";
import {useTranslation} from "../../../../hooks/useTranslation";

const apiURL2 = process.env.REACT_APP_API_URL2;

const QuotationsEdit = ({ tabKey = "0" }) => {
    const {t} = useTranslation();
    let date = new Date();
    const dispatch = useTaggedDispatch({ tabKey });
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const PRODUCTS_DATA = useSelector((state) => state.PRODUCTS_DATA);
    const SALES = useSelector((state) => state.SALES);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const SALES_SETTINGS = useSelector((state) => state.SALES_SETTINGS);
    const editQuotations = useSelector((state) => state.SALES.editQuotations[tabKey]);
    const clientVatCategory = editQuotations?.vatCategory || "Normal VAT";
    const clientVatReason = editQuotations?.clientVatReason || "";
    const clientCustomVat = editQuotations?.clientCustomVat || 0;
    const printLayout = useSelector((state) => state.SALES.printLayout);

    const requestData = {
        company: company.id
    }
    const currentUser = getCurrentUser();
    const requestData2 = {
        company: company.id,
        year: String(company.year),
        isActive: "active",
        userId: currentUser.id
    }
    const requestData3 = {
        company: company.id,
        year: String(company.year),
    }
    let requestDataF = {
        company: company.id,
        year: String(company.year),
        name: ''
    }
    // Options for Document Type Dropdown
    const allDocumentTypes = SETTINGS.settings.advancedTypes;
    const measurementUnitOptions= getMyData({type: 'mu', settings: SETTINGS});
    const quotationsDT = getObjectFromArrayOfObjects(
        allDocumentTypes,
        "Quotations",
        "section"
    );
    const documentTypesOptions = getOptionsByData(
        quotationsDT,
        "_id",
        "name"
    );
    const productCodeColumns = [
        {
            label: t('SalesNew.productCodeTable.code'),
            name: "code",
        },
        {
            label: t('SalesNew.productCodeTable.alternativeCode'),
            name: "alternateCode",
        },
        {
            label: t('SalesNew.productCodeTable.productName'),
            name: "name",
        },
        {
            label: t('SalesNew.productCodeTable.alternativeName'),
            name: "alternateName",
        },
    ];
    const clientDropdownColumns = [
        {
            label: t('SalesNew.clientTable.code'),
            name: "systemCode",
        },
        {
            label: t('SalesNew.clientTable.name'),
            name: "name",
        },
        {
            label: t('SalesNew.clientTable.phone'),
            name: "phone",
        },
        {
            label: t('SalesNew.clientTable.email'),
            name: "email",
        },
        {
            label: t('SalesNew.clientTable.vatNumber'),
            name: "vatNumber",
        },
    ];
    const clientInstallationsDropdownColumns = [
        {
            label: t('SalesNew.installationTable.type'),
            name: "type",
        },
        {
            label: t('SalesNew.installationTable.address'),
            name: "address",
        }
    ];

    const [refreshPage, setRefreshPage] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const [showCategoryConfirmation, setshowCategoryConfirmation] = useState(false);
    const [tempCatValue, setTempCatValue] = useState({});
    const [showProductTableSpinner, setProductTableSpinner] = useState('false');
    const [quotationsProductList, setQuotationsProductList] = useState(PRODUCTS_DATA.products.slice());
    const [clientsListData, setClientsListData] = useState(CLIENTS_DATA.clients.slice());
    const [clientInstallationListData, setClientInstallationListData] = useState(CLIENTS_DATA.installations.slice());
    const [showDiscountModal, setShowDiscountModal] = useState(false);

    useEffect(() => {
        dispatch(fetchAdvancedTypes(requestData));
        dispatch(fetchSalesGeneralSettings(requestData2));
        dispatch(fetchPOS(requestData2));
        dispatch(fetchBankAccounts(requestData2));
        dispatch(fetchCashRegisters(requestData2));
        dispatch(fetchClients(requestData3, setClientsListData));
        dispatch(fetchProductsONChange(requestData3, setQuotationsProductList));
    }, []);

    useEffect(() => {
        if (editQuotations.documentType !== "") {
            let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, editQuotations.documentType, '_id');
            if (dtData.length > 0) {
                let selectedDocumentTypeData = dtData['0'];
                if(editQuotations.installation !== undefined && editQuotations.installation !== ''){
                    let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, editQuotations.installation);
                    setPreNumberGreekOptions(newPreNumbers);
                }
            }
        }
    }, [editQuotations.documentType, SETTINGS.settings.advancedTypes]);

    let ptTypes = SALES_SETTINGS.salesGeneralSettings.paymentTypes;
    const paymentTypeOptions = getOptionsByData(ptTypes, "_id", "name");
    const [preNumberGreekOptions, setPreNumberGreekOptions] = useState([]);
    const COMPANY_DATA = useSelector((state) => state.COMPANY_DATA);

    let selectedDocumentTypeData = [];
    let dtInstallationsOptions = [];
    let disabledFields = false;
    let printTemplateData = getQuotationsPrintData("editQuotations", editQuotations, COMPANY_DATA, null, printLayout);
    const componentRef = useRef(null);
    const componentRefA5 = useRef(null);
    const componentRefA5En = useRef(null);
    const componentRefDA5 = useRef(null);
    const componentRefDA5En = useRef(null);
    const componentRefEn = useRef(null);

    if (editQuotations.documentType === undefined || editQuotations.documentType === '') {
        disabledFields = true;
    } else {
        let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, editQuotations.documentType, '_id');
        if (dtData.length > 0) {
            selectedDocumentTypeData = dtData['0'];
            dtInstallationsOptions = getOptionsByData(selectedDocumentTypeData['documentNumbering'], "installationMasterId", "installation");
            dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
        }
    }
    useEffect(() => {
        printTemplateData = getQuotationsPrintData("editQuotations", editQuotations, COMPANY_DATA, null, printLayout);
    }, [printLayout])

    const clientProductsColumns = [
        {
            name: "No",
            field: "no",
            width: "40px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNew.productTable.code.code'),
            field: "code",
            width: "120px",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: quotationsProductList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('SalesNew.productTable.code.placeholder')
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('SalesNew.productTable.name.name'),
            field: "name",
            width: "400px",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: quotationsProductList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('SalesNew.productTable.name.placeholder')
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('SalesNew.productTable.quantity'),
            field: "quantity",
            width: "90px",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'accounting',
                config: {
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNew.productTable.mu'),
            field: "muLabel",
            editable: false,
            width: "60px",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNew.productTable.unitPrice'),
            field: "unitPrice",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            width: "130px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    decimalLimit: 3,
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNew.productTable.discount'),
            field: "discount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            width: "80px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: "%",
            field: "isPerDiscount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'radio',
                name: 'discountType',
                radioLogic: 'oneperrow',
                options: [{
                    value: true,
                    label: 'True'
                }, {
                    value: false,
                    label: 'False'
                }]
            }
        },
        {
            name: "€",
            field: "isDiscountAmount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'radio',
                radioLogic: 'oneperrow',
                name: 'discountType',
                options: [{
                    value: true,
                    label: 'True'
                }, {
                    value: false,
                    label: 'False'
                }]
            }
        },
        {
            name: t('SalesNew.productTable.vat'),
            field: "vatPercentage",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNew.productTable.netValue'),
            field: "netValue",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            width: "150px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNew.productTable.taxes'),
            field: "taxes",
            editable: false,
            width: "90px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNew.productTable.totalValue'),
            field: "totalValue",
            editable: true,
            width: "150px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
    ]

    const handleConfirmCategory = async () => {
        let editQuotationsData = {};
        let value = tempCatValue.new;
        editQuotationsData.documentType = value;
        editQuotationsData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
        editQuotationsData.corelatedDocument = "";
        editQuotationsData.corelatedDocumentName = "";
        editQuotationsData.correlatedDclObj = "";
        editQuotationsData.correlatedDclName = "";
        const selectedDocumentTypeData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, value, "_id");
        if (selectedDocumentTypeData.length > 0) {
            let selectedDTData = selectedDocumentTypeData['0'];
            editQuotationsData.fuelInvoice = selectedDTData?.fuelInvoice === "active" ? "active" : "inactive";
            if (selectedDTData?.reverseDeliveryNotePurpose) editQuotationsData.reverseDeliveryNotePurpose = selectedDTData.reverseDeliveryNotePurpose;
            editQuotationsData.isDeliveryNote = selectedDTData?.isDeliveryNote === "active";
            if (selectedDTData?.vatPaymentSuspension === "active") {
                editQuotationsData.vatPaymentSuspension = true;
            } else {
                editQuotationsData.vatPaymentSuspension = undefined;
            }
            setActiveTab(0);
            editQuotationsData.paymentType = "";
            editQuotationsData.paymentTypeName = "";
            editQuotationsData.bankAccount = "";
            editQuotationsData.bankAccountName = "";
            let selectedInstallation = getSelectedInstallation(selectedDTData['documentNumbering']);

            if (Object.keys(selectedInstallation).length > 0) {
                editQuotationsData.installation = selectedInstallation.installationMasterId;
                editQuotationsData.preNumber = selectedInstallation.preNumber;
                editQuotationsData.installationMode = selectedInstallation.numberingMode;
                editQuotationsData.numberingMode = selectedInstallation.numberingMode;
                editQuotationsData.number = selectedInstallation.number + 1;
            } else if(dtInstallationsOptions.length === 1){
                editQuotationsData.installation = dtInstallationsOptions[0].value;
                editQuotationsData.preNumber = "";
                editQuotationsData.number = "";
                editQuotationsData.installationMode = "";
                editQuotationsData.numberingMode = "";
            } else {
                editQuotationsData.installation = "";
                editQuotationsData.preNumber = "";
                editQuotationsData.number = "";
                editQuotationsData.installationMode = "";
                editQuotationsData.numberingMode = "";
            }

            let newPreNumbers = getSelectedPreNumbers(selectedDTData['documentNumbering'], preNumberGreek, selectedInstallation.installationMasterId);
            setPreNumberGreekOptions(newPreNumbers);

            editQuotationsData.salePurpose = selectedDTData.proposedSalePurpose;
            editQuotationsData.specialInvoiceCategory = selectedDTData?.specialInvoiceCategory ? selectedDTData.specialInvoiceCategory : "";

            editQuotationsData.products = [];
            editQuotationsData.client = "";
            editQuotationsData.clientName = "";
            editQuotationsData.clientCode = "";
            editQuotationsData.address = "";
            editQuotationsData.vat = "";
            editQuotationsData.doy = "";
            editQuotationsData.city = "";
            editQuotationsData.amka = "";
            editQuotationsData.clientCategoryName = "";
            editQuotationsData.clientCategory = "";
            editQuotationsData.country = "";
            editQuotationsData.pc = "";
            editQuotationsData.email = "";
            editQuotationsData.phone = "";
            editQuotationsData.activity = "";
            editQuotationsData.vatCategory = "";
            setClientInstallationListData(CLIENTS_DATA.installations.slice());
            editQuotationsData.clientInstallationType = "";
            editQuotationsData.clientInstallationId = "";
        }
        dispatch(setEditQuotations({ ...editQuotations, ...editQuotationsData }));
        setshowCategoryConfirmation(false);
    }

    const onChangeSearch = (keyword, setData) => {
        requestDataF.name = keyword
        if(keyword.length >= 2) {
            dispatch(fetchClients(requestDataF, setData))
        }
    }

    const handleOnChange = async (e, type = "default", ddname = '', currentQuotationsState = null) => {
        if (!ACTIVITY.saveEditQuotations) dispatch(setSaveEditQuotations(true));

        let name;
        let value = '';
        if (type === 'dd' || type === 'ac') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === 'acdd') {
            e = e.row;
            value = e._id;
            name = ddname;
        } else if (type === 'tp') {
            value = e;
            name = ddname;
        } else if (type === "checkbox") {
            value = e.target.checked;
            name = ddname;
        } else if (type === "bettercheckbox") {
            value = e.target.checked ? "active" : "inactive";
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }

        let quotationsData = Object.assign({}, currentQuotationsState ? currentQuotationsState : editQuotations);
        let editQuotationsData = {};

        if (name === 'documentType' && quotationsData.documentType !== value) {
            if (!isEmpty(SALES_SETTINGS?.salesGeneralSettings?.proposedSaleNotes)) {
                editQuotationsData["notes"] = SALES_SETTINGS.salesGeneralSettings.proposedSaleNotes;
            }
            if (quotationsData.documentType !== "") {
                editQuotationsData.corelatedDocument = "";
                editQuotationsData.corelatedDocumentName = "";
                editQuotationsData.correlatedDclObj = "";
                editQuotationsData.correlatedDclName = "";
                setshowCategoryConfirmation(true);
                setTempCatValue({ e: e, new: value, old: quotationsData.documentType });
            } else {
                editQuotationsData[name] = value;
                let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, value, '_id');
                if (dtData.length > 0) {
                    dtInstallationsOptions = getOptionsByData(dtData['0']['documentNumbering'], "installationMasterId", "installation");
                    dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
                }
                editQuotationsData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
                const selectedDocumentTypeData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, value, "_id");
                if (selectedDocumentTypeData.length > 0) {
                    let selectedDTData = selectedDocumentTypeData['0'];
                    editQuotationsData.fuelInvoice = selectedDTData?.fuelInvoice === "active" ? "active" : "inactive";
                    if (selectedDTData?.reverseDeliveryNotePurpose) editQuotationsData.reverseDeliveryNotePurpose = selectedDTData.reverseDeliveryNotePurpose
                    editQuotationsData.isDeliveryNote = selectedDTData?.isDeliveryNote === "active";
                    if (selectedDTData?.vatPaymentSuspension === "active") {
                        editQuotationsData.vatPaymentSuspension = true;
                    } else {
                        editQuotationsData.vatPaymentSuspension = undefined;
                    }
                    setActiveTab(0);
                    let selectedInstallation = getSelectedInstallation(selectedDTData['documentNumbering']);
                    if (Object.keys(selectedInstallation).length > 0) {
                        editQuotationsData.installation = selectedInstallation.installationMasterId;
                        editQuotationsData.preNumber = selectedInstallation.preNumber;
                        editQuotationsData.installationMode = selectedInstallation.numberingMode;
                        editQuotationsData.numberingMode = selectedInstallation.numberingMode;
                        if(editQuotationsData.numberingMode !== "manual") {
                            editQuotationsData.number = selectedInstallation.number + 1;
                        }
                    } else if(dtInstallationsOptions.length === 1){
                        editQuotationsData.installation = dtInstallationsOptions[0].value;
                        editQuotationsData.preNumber = "";
                        editQuotationsData.number = "";
                        editQuotationsData.installationMode = "";
                        editQuotationsData.numberingMode = "";
                    } else {
                        editQuotationsData.installation = "";
                        editQuotationsData.preNumber = "";
                        editQuotationsData.number = "";
                        editQuotationsData.installationMode = "";
                        editQuotationsData.numberingMode = "";
                    }

                    let newPreNumbers = getSelectedPreNumbers(selectedDTData['documentNumbering'], preNumberGreek, editQuotationsData.installation);
                    setPreNumberGreekOptions(newPreNumbers);
                    editQuotationsData.salePurpose = selectedDTData.proposedSalePurpose;
                    editQuotationsData.specialInvoiceCategory = selectedDTData?.specialInvoiceCategory ? selectedDTData.specialInvoiceCategory : "";
                }
            }
        } else {
            editQuotationsData[name] = value;
        }

        if (name === 'client') {
            let selectedClient = getObjectFromArrayOfObjects(clientsListData, value, '_id');
            await axios.get(apiURL2 + `/client/get-client-id-by/${value}`)
                .then((res) => {
                    if (res.data && res.data.status === "200") {
                        selectedClient['0'] = res.data.data;
                    }
                }).catch((err) => {
                    console.log(err);
                })
            if (selectedClient.length > 0) {
                let sClient = selectedClient['0'];
                editQuotationsData.clientName = sClient.name;
                editQuotationsData.clientCode = !isEmpty(sClient.manualCode) ? sClient.manualCode : sClient.systemCode;
                editQuotationsData.address = sClient.address;
                editQuotationsData.vat = sClient.vatNumber;
                editQuotationsData.doy = getLabelByValue(getDOYOptions(), Number(sClient.DOY), 'value');
                editQuotationsData.city = sClient.city;
                editQuotationsData.amka = sClient?.amka;
                editQuotationsData.clientCategoryName = sClient?.categoryName;
                editQuotationsData.clientCategory = sClient?.category;
                editQuotationsData.country = sClient.country;
                editQuotationsData.pc = sClient.postalCode;
                editQuotationsData.email = sClient.email;
                editQuotationsData.phone = sClient.phone;
                editQuotationsData.activity = sClient.activity;
                editQuotationsData.vatCategory = sClient.vatCategory;
                sClient.installations.map(installation => {
                    installation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
                    return installation;
                })
                setClientInstallationListData(sClient.installations);
                editQuotationsData.clientInstallationType = sClient.installations[0]?.type;
                editQuotationsData.clientInstallationId = sClient.installations[0]?.no;
            }
            if(!isEmpty(quotationsData.correlatedDclObj) && (editQuotationsData?.client !== quotationsData?.client)) {
                editQuotationsData.correlatedDclObj = "";
                editQuotationsData.correlatedDclName = "";
            }
        }

        if(name === 'clientInstallation'){
            let selectedClientInstallation = "";
            clientInstallationListData.map(installation => {
                if(value === installation._id){
                    selectedClientInstallation = installation;
                }
                return installation;
            })
            if(selectedClientInstallation !== ""){
                editQuotationsData.clientInstallationType = selectedClientInstallation.type;
                editQuotationsData.clientInstallationId = selectedClientInstallation.no;
                editQuotationsData.address = selectedClientInstallation.address;
                editQuotationsData.doy = getLabelByValue(getDOYOptions(), Number(selectedClientInstallation.DOY), 'value');
                editQuotationsData.city = selectedClientInstallation.city;
                editQuotationsData.pc = selectedClientInstallation.postalCode;
            }
        }

        if (name === 'paymentType') {
            editQuotationsData.paymentTypeName = getLabelByValue(paymentTypeOptions, value, 'value');

            let paymentTypesData = getObjectFromArrayOfObjects(SALES_SETTINGS.salesGeneralSettings.paymentTypes, value, '_id');
            if (paymentTypesData && paymentTypesData.length > 0) {
                let selectedPaymentType = paymentTypesData['0'];
                if (selectedPaymentType?.type === "pos") {
                    editQuotationsData.bankAccount = selectedPaymentType.options?.preSelectedPosBankAccount;
                }

                if (selectedPaymentType?.type === "bank-account" || selectedPaymentType?.type === "bank-account-outside" || selectedPaymentType?.type === "web-banking") {
                    editQuotationsData.bankAccount = selectedPaymentType.options?.preSelectedPosBankAccount;
                }

                if (selectedPaymentType?.type === "cash") {
                    editQuotationsData.bankAccount = "";
                }
            }
        }

        if (name === 'installation') {
            editQuotationsData.installationName = getLabelByValue(dtInstallationsOptions, value, 'value');
            editQuotationsData.preNumber = getPreNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            editQuotationsData.installationMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            editQuotationsData.numberingMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            if(editQuotationsData.numberingMode !== "manual") {
                editQuotationsData.number = getNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId') + 1;
            }
            let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, value);
            setPreNumberGreekOptions(newPreNumbers);
        }
        if (name === "salePurpose") {
            editQuotationsData['salePurposeName'] = "";
        }

        if ((name === 'documentType' || name === 'preNumber' || name === 'installation') &&
            (
                (quotationsData.documentType !== '' || editQuotationsData.documentType !== '') &&
                (quotationsData.preNumber !== '' || editQuotationsData.preNumber !== '') &&
                (quotationsData.installation !== '' || editQuotationsData.installation !== '')
            )) {
            let checkAtParams = {};
            checkAtParams.company = company.id;
            checkAtParams.id = !editQuotationsData.documentType ? quotationsData.documentType : editQuotationsData.documentType;
            checkAtParams.preNumber = !editQuotationsData.preNumber ? quotationsData.preNumber : editQuotationsData.preNumber;
            checkAtParams.installation = !editQuotationsData.installation ? String(quotationsData?.installation) : String(editQuotationsData?.installation);

            if (checkAtParams.id && checkAtParams.preNumber && checkAtParams.installation) {
                if(currentQuotationsState) {
                    return { ...quotationsData, ...editQuotationsData };
                } else {
                    dispatch(setEditQuotations({ ...quotationsData, ...editQuotationsData }));
                }
            } else {
                if(currentQuotationsState) {
                    return { ...quotationsData, ...editQuotationsData };
                } else {
                    dispatch(setEditQuotations({ ...quotationsData, ...editQuotationsData }));
                }
            }
        } else {
            if(currentQuotationsState) {
                return { ...quotationsData, ...editQuotationsData };
            } else {
                dispatch(setEditQuotations({ ...quotationsData, ...editQuotationsData }));
            }
        }
    }

    const quickClientFields = [
        {
            name: t('SalesNew.quickClientTable.name'),
            field: "name",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.vatCategory'),
            field: "vatCategory",
            editable: true,
            inputType: {
                options: getVatCategoryOptions(),
                type: 'select',
            }
        },
        {
            name: t('SalesNew.quickClientTable.vatNumber'),
            field: "vatNumber",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: "ΑΜΚΑ Ασθενή",
            field: "amka",
            hidden: editQuotations?.clientCategoryName !== "Patient",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.phone'),
            field: "phone",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.email'),
            field: "email",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.address'),
            field: "address",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesNew.quickClientTable.city'),
            field: "city",
            editable: true,
            inputType: {
                type: "text",
            },
        },
    ];

    const [updateSaleAmounts, setUpdateSaleAmounts] = useState(false);

    const quotationsProductListActions = {
        insert: async (e, data, currentState = null) => {
            if (!ACTIVITY.saveEditQuotations) dispatch(setSaveEditQuotations(true));
            let currentQuotationsState = currentState ? currentState : editQuotations;

            let productData = null;
            if (data && data?.field === 'code') {
                await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(data.value)}`, {params: company})
                    .then(res => {
                        if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                            productData = res.data.data['0'];
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
            }
            if (data && data?.field === 'name') {
                await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-name/${encodeURIComponent(data.value)}`,{params :company})
                    .then(res => {
                        if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                            productData = res.data.data['0'];
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
            }
            if (productData !== null && Object.keys(productData).length > 0) {
                if (e.key !== "Enter") {
                    setProductTableSpinner('true');
                    let tempNewProduct = Object.assign({}, SALES.editQuotationNewProduct);

                    if (currentQuotationsState.client && currentQuotationsState.client !== '') {
                        await axios.post(`${process.env.REACT_APP_API_URL2}/category/get-product-code-by-price`, { _id: productData._id, client: currentQuotationsState.client, company: company.id })
                            .then((res) => {
                                if (res.data.status === "200") {
                                    let pldata = res.data?.data;
                                    productData.vatIncluded = pldata.vatIncluded;
                                    tempNewProduct.isPerDiscount = pldata.isPerDiscount;
                                    tempNewProduct.isDiscountAmount = pldata.isDiscountAmount;
                                    tempNewProduct.discount = pldata.discount;

                                    productData.price = pldata.productPrice;
                                    productData.unitPrice = filterNaNValue(pldata.productPrice);
                                }
                            }).catch((error) => {
                                setProductTableSpinner('false');
                                console.log(error);
                            })
                    }
                    if (currentQuotationsState.fuelInvoice === "active") {
                        tempNewProduct.fuelCode = productData.fuelCode;
                    }
                    if (productData?.invoiceDetailType) {
                        tempNewProduct.invoiceDetailType = productData.invoiceDetailType;
                    } else {
                        tempNewProduct.invoiceDetailType = undefined;
                    }
                    if (productData?.specialOption) {
                        tempNewProduct.specialOption = productData.specialOption;
                    }
                    if (productData?.notVAT195) {
                        tempNewProduct.notVAT195 = productData.notVAT195;
                    }
                    if (productData?.showAlternativeNameOnPrint === "true") {
                        tempNewProduct.showAlternativeNameOnPrint = "true";
                        tempNewProduct.alternativeName = productData.alternateName;
                    }
                    if (productData?.showAlternativeCodeOnPrint === "true") {
                        tempNewProduct.showAlternativeCodeOnPrint = "true";
                        tempNewProduct.alternativeCode = productData.alternateCode;
                    }
                    tempNewProduct.name = productData?.name;
                    tempNewProduct.code = productData?.code;
                    tempNewProduct.quantity = 1;
                    tempNewProduct.mu = productData?.measurementUnit;
                    tempNewProduct.muLabel = getLabelByValue(measurementUnitOptions, productData?.measurementUnit.toString(), 'value');
                    tempNewProduct.discount = 0;
                    tempNewProduct.taxes = 0;
                    if (!isEmpty(productData?.deductionsEuro) && parseFloat(productData?.deductionsEuro) > 0) {
                        tempNewProduct.deductionsEuro = Number(parseFloat(productData?.deductionsEuro).toFixed(2));
                    }
                    if (productData?.vatIncluded === "true") {
                        const price = parseFloat(productData.price);
                        const vat = isNaN(productData.vat) ? 0 : parseFloat(productData.vat);
                        if (vat > 0) {
                            tempNewProduct.unitPrice = Number(Number(price/(1 + vat/100)).toFixed(2));
                        } else {
                            tempNewProduct.unitPrice = parseNumber(productData.price);
                        }
                    } else {
                        tempNewProduct.unitPrice = parseNumber(productData.price);
                    }
                    tempNewProduct[data.field] = data.value;
                    if (data.field === 'isPerDiscount' && (data.value === "on" || data.value === "true")) {
                        tempNewProduct.isPerDiscount = "true";
                        tempNewProduct.isDiscountAmount = "false";
                    }
                    if (data.field === 'isDiscountAmount' && (data.value === "on" || data.value === "true")) {
                        tempNewProduct.isPerDiscount = "false";
                        tempNewProduct.isDiscountAmount = "true";
                    }
                    let discountType = 'euro';
                    if (tempNewProduct.isPerDiscount === 'true') {
                        discountType = 'per';
                    }
                    if(productData?.isTaxLine === "true"){
                        tempNewProduct.vatPercentage  = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                        if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                            tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(tempNewProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
                        } else if (clientVatCategory === "Zero VAT") {
                            tempNewProduct.vatId = "7";
                        } else {
                            tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                        }
                        tempNewProduct.vatReason      = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
                        tempNewProduct.unitPrice      = getPriceExclusiveVat(tempNewProduct.unitPrice, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded);
                        tempNewProduct.discount       = getDiscountExclusiveVat(tempNewProduct.discount, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded, discountType);
                        tempNewProduct.netValue       = 0;
                        tempNewProduct.withHoldTax    = productData.withholdTax;
                        tempNewProduct.otherTax       = productData.otherTaxes;
                        tempNewProduct.stamp          = productData.stamp;
                        tempNewProduct.fee           = productData.fee;
                        tempNewProduct._id            = productData._id;
                        tempNewProduct.isTaxLine      = productData.isTaxLine;
                        tempNewProduct.classificationCategory = '';
                        tempNewProduct.classificationType = '';
                        tempNewProduct.vatExpenseType = '';
                        tempNewProduct.isTaxLineWithoutVat      = productData.isTaxLineWithoutVat;
                        tempNewProduct.taxes          = getNetValue(tempNewProduct.unitPrice, tempNewProduct.quantity, tempNewProduct.discount, discountType);
                        tempNewProduct.otherTaxEuro   = getProductOtherTax(tempNewProduct, SETTINGS);
                        tempNewProduct.witholdTaxEuro = getProductWithholdTax(tempNewProduct, SETTINGS);
                        tempNewProduct.feeEuro        = getProductFee(tempNewProduct, SETTINGS);
                        tempNewProduct.stampEuro      = getProductStamp(tempNewProduct, SETTINGS);
                        tempNewProduct.vat            = getVatValue(tempNewProduct.taxes, tempNewProduct.vatPercentage);
                        tempNewProduct.totalValue     = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes);
                    } else {
                        tempNewProduct.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                        if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                            tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(tempNewProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
                        } else if (clientVatCategory === "Zero VAT") {
                            tempNewProduct.vatId = "7";
                        } else {
                            tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                        }
                        tempNewProduct.vatReason = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
                        tempNewProduct.unitPrice = getPriceExclusiveVat(tempNewProduct.unitPrice, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded);
                        tempNewProduct.discount = getDiscountExclusiveVat(tempNewProduct.discount, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded, discountType);
                        tempNewProduct.netValue = getNetValue(tempNewProduct.unitPrice, tempNewProduct.quantity, tempNewProduct.discount, discountType);
                        tempNewProduct.withHoldTax = productData.withholdTax;
                        tempNewProduct.otherTax = productData.otherTaxes;
                        tempNewProduct.fee = productData.fee;
                        tempNewProduct.stamp = productData.stamp;
                        tempNewProduct._id = productData._id;
                        tempNewProduct.classificationCategory = '';
                        tempNewProduct.classificationType = '';
                        tempNewProduct.vatExpenseType = '';
                        tempNewProduct.taxes = getTaxes(tempNewProduct, SETTINGS);
                        tempNewProduct.otherTaxEuro = getProductOtherTax(tempNewProduct, SETTINGS);
                        tempNewProduct.witholdTaxEuro = getProductWithholdTax(tempNewProduct, SETTINGS);
                        tempNewProduct.feeEuro = getProductFee(tempNewProduct, SETTINGS);
                        tempNewProduct.stampEuro        = getProductStamp(tempNewProduct, SETTINGS);
                        if (productData.vatIncluded === "true") {
                            let price = isNaN(Number(productData.price)) ? 0 : productData.price;
                            tempNewProduct.vat = getVatValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, price);
                            tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes, tempNewProduct.vat);
                        } else {
                            tempNewProduct.vat = getVatValue(tempNewProduct.netValue, tempNewProduct.vatPercentage);
                            tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes);
                        }
                    }
                    let oldSalesProducts = currentQuotationsState.products;
                    let updatePriceListNewProduct = Object.assign({}, tempNewProduct);
                    updatePriceListNewProduct.name = tempNewProduct.name;
                    updatePriceListNewProduct.code = tempNewProduct.code;
                    updatePriceListNewProduct.no = oldSalesProducts.length + 1;
                    updatePriceListNewProduct.id = oldSalesProducts.length + 1;
                    updatePriceListNewProduct._id = tempNewProduct._id

                    if(setEditQuotationNewProduct) dispatch(setEditQuotationNewProduct(tempNewProduct));

                    let pPlroducts = [...oldSalesProducts, updatePriceListNewProduct];
                    let productTotals = getSalesTotals(pPlroducts, SETTINGS);
                    let productSalesTaxes = getSalesTaxesData(pPlroducts, currentQuotationsState.extraData, productTotals, SETTINGS);

                    let extraData = {...currentQuotationsState.extraData};
                    if(productSalesTaxes.length > 0){
                        productSalesTaxes.map((salesTax) => {
                            if(salesTax.vatPercentage === "Invoice Level Tax"){
                                extraData.witholdTaxEuro = salesTax.withholdTaxes;
                                extraData.otherTaxEuro = salesTax.otherTaxes;
                                extraData.feeEuro = salesTax.fees;
                                extraData.stampEuro = salesTax.stamp;
                            }
                            return salesTax;
                        })
                    }
                    let totalTaxes = 0;
                    let withHoldTaxes = 0;
                    let deductions = 0;
                    if(productSalesTaxes.length > 0 && productSalesTaxes[0].vatPercentage === "Invoice Level Tax"){
                        totalTaxes = parseFloat( (Number(productSalesTaxes[0].otherTaxes) + Number(productSalesTaxes[0].fees) + Number(productSalesTaxes[0].stamp)).toString());
                        withHoldTaxes = parseFloat(productSalesTaxes[0].withholdTaxes).toFixed(2);
                        deductions = parseFloat(productSalesTaxes[0].deductions).toFixed(2);
                    }
                    if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
                        productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
                        productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
                    }

                    if(setEditQuotationNewProduct) dispatch(setEditQuotationNewProduct(SALES.editQuotationNewProductInitialValue));
                    if(!isEmpty(currentState)) {
                        setProductTableSpinner('false');
                        return { ...currentQuotationsState, products: pPlroducts, salesTaxes: productSalesTaxes, ...productTotals };
                    } else {
                        dispatch(setEditQuotations({ ...currentQuotationsState, products: pPlroducts, salesTaxes: productSalesTaxes, ...productTotals }));
                    }
                }
            }
            setProductTableSpinner('false');
        },
        update: async (data, id, rowIndex, e, currentState = null) => {
            if (!ACTIVITY.saveEditQuotations) dispatch(setSaveEditQuotations(true));

            setProductTableSpinner('true');
            let quickEdit = false;
            let foundProduct;
            let productData = null;
            let currentQuotationsState = currentState ? currentState : editQuotations;
            let plProducts = currentQuotationsState.products.slice();

            if (data.quickEdit) {
                let qeProduct = await getObjectFromArrayOfObjects(plProducts, id, '_id');
                if (qeProduct.length > 0) {
                    data.code = qeProduct['0'].code;
                }
                foundProduct = plProducts.find(item => item._id === id);
            } else {
                foundProduct = plProducts.find(item => item.id === id);
            }
            if(foundProduct.quickEdit === true) quickEdit = true;
            if (data.isPerDiscount && (data.isPerDiscount === "on" || data.isPerDiscount === "true")) {
                data.isPerDiscount = "true";
                data.isDiscountAmount = "false";
            }
            if (data.isDiscountAmount && (data.isDiscountAmount === "on" || data.isDiscountAmount === "true")) {
                data.isPerDiscount = "false";
                data.isDiscountAmount = "true";
            }
            if (data.name && data.name === '') {
                toast.error("Name is mandatory field.");
            } else if (data.code && data.code === '') {
                toast.error("Code is mandatory field.");
            } else {
                if (foundProduct) {
                    let papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(foundProduct.code)}`;
                    if (data.code && data.code !== '') {
                        papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(data.code)}`;
                    } else if (data.name && data.name !== '') {
                        papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-name/${encodeURIComponent(data.name)}`;
                    }
                    let loadingProduct = true;
                    if (loadingProduct) {
                        await axios.get(papiUrl ,{params: company})
                            .then(res => {
                                if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                                    productData = res.data.data['0'];
                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    }
                    if(data.name || data.code) {
                        quickEdit = false;
                    }
                    if (data.unitPrice) {
                        productData.price = data.unitPrice;
                    } else if (foundProduct.unitPrice) {
                        productData.price = foundProduct.unitPrice;
                    }
                    if (((data.code && data.code !== '') || (data.name && data.name !== ''))) {
                        if (currentQuotationsState.client && currentQuotationsState.client !== '') {
                            await axios.post(`${process.env.REACT_APP_API_URL2}/category/get-product-code-by-price`, { _id: productData._id, client: currentQuotationsState.client, company: company.id })
                                .then((res) => {
                                    if (res.data.status === "200") {
                                        let plProductData = res.data.data;
                                        data.vatIncluded = plProductData.vatIncluded;
                                        productData.vatIncluded = plProductData.vatIncluded;
                                        data.discount = plProductData?.discount;
                                        data.isPerDiscount = plProductData?.isPerDiscount;
                                        data.isDiscountAmount = plProductData?.isDiscountAmount;
                                        data.name = plProductData?.name;
                                        data.code = plProductData?.code;
                                        data.mu = plProductData?.measurementUnit;
                                        data.muLabel = getLabelByValue(measurementUnitOptions, plProductData?.measurementUnit.toString(), 'value');
                                        if(!quickEdit) data.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                                        if(!quickEdit) data.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                                        if(!quickEdit) data.vatReason = clientVatReason !== "" ? clientVatReason : plProductData?.vatReason;
                                        data.unitPrice = filterNaNValue(plProductData.productPrice);
                                        productData.price = filterNaNValue(plProductData.productPrice);
                                        productData.unitPrice = filterNaNValue(plProductData.productPrice);
                                    }
                                }).catch((err) => {
                                    console.log(err);
                                })
                        }
                        data.withHoldTax = productData.withholdTax;
                        data.otherTax = productData.otherTaxes;
                        data.stamp = productData.stamp;
                        data.fee = productData.fee;
                    }
                    if (productData?.vatIncluded === "true" && (data.name || data.code)) {
                        const price = parseFloat(productData.price);
                        const vat = isNaN(productData.vat) ? 0 : parseFloat(productData.vat);
                        if (vat > 0) {
                            data.unitPrice = Number(Number(price/(1 + vat/100)).toFixed(2));
                        } else {
                            data.unitPrice = parseNumber(productData.price);
                        }
                    } else {
                        data.unitPrice = parseNumber(productData.price);
                    }
                    foundProduct = { ...foundProduct, ...data }
                    if (currentQuotationsState.enablePeppol === "active") {
                        if (productData.cpvCode) {
                            foundProduct.cpvCode = productData.cpvCode;
                        } else {
                            foundProduct.cpvCode = undefined;
                        }
                    }
                    if (currentQuotationsState.fuelInvoice === "active") {
                        foundProduct.fuelCode = productData.fuelCode;
                    }
                    if (productData?.invoiceDetailType) {
                        foundProduct.invoiceDetailType = productData.invoiceDetailType;
                    } else {
                        foundProduct.invoiceDetailType = undefined;
                    }
                    if (productData?.specialOption) {
                        foundProduct.specialOption = productData.specialOption;
                    } else {
                        foundProduct.specialOption = undefined;
                    }
                    if (productData?.notVAT195) {
                        foundProduct.notVAT195 = productData.notVAT195;
                    } else {
                        foundProduct.notVAT195 = undefined;
                    }
                    if (!quickEdit) {
                        if (productData?.showAlternativeNameOnPrint === "true") {
                            foundProduct.showAlternativeNameOnPrint = "true";
                            foundProduct.alternativeName = productData.alternateName;
                        } else {
                            foundProduct.showAlternativeNameOnPrint = undefined;
                            foundProduct.alternativeName = undefined;
                        }
                    }
                    if (productData?.showAlternativeCodeOnPrint === "true") {
                        foundProduct.showAlternativeCodeOnPrint = "true";
                        foundProduct.alternativeCode = productData.alternateCode;
                    } else {
                        foundProduct.showAlternativeCodeOnPrint = undefined;
                        foundProduct.alternativeCode = undefined;
                    }
                    let discountType = 'euro';
                    if (foundProduct.isPerDiscount === 'true') {
                        discountType = 'per'
                    }
                    if (data.discount && data.discount !== '') {
                        foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatIncluded, discountType);
                    }
                    if (data.netValue && data.netValue !== '' && foundProduct.isTaxLine !== "true") {
                        foundProduct.unitPrice = getUnitPrice(data.netValue, foundProduct.quantity, foundProduct.discount, discountType);
                    } else {
                        if(foundProduct.isTaxLine === "true"){
                            foundProduct.netValue = 0;
                        } else {
                            foundProduct.netValue = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                        }
                    }
                    foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                    foundProduct.otherTaxEuro   = getProductOtherTax(foundProduct, SETTINGS);
                    foundProduct.feeEuro   = getProductFee(foundProduct, SETTINGS);
                    foundProduct.stampEuro   = getProductStamp(foundProduct, SETTINGS);
                    if (!isEmpty(productData?.deductionsEuro) && parseFloat(productData?.deductionsEuro) > 0) {
                        foundProduct.deductionsEuro = Number(parseFloat(productData?.deductionsEuro).toFixed(2));
                    }
                    if(foundProduct.isTaxLine === "true"){
                        foundProduct.taxes = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                    } else {
                        foundProduct.taxes = getTaxes(foundProduct, SETTINGS);
                    }
                    let userTotalValInput = 0;
                    if (data.totalValue && data.totalValue !== '') {
                        if(foundProduct.isTaxLine === "true"){
                            foundProduct.taxes = getNetValueByTotalValue(data.totalValue, foundProduct.vatPercentage, foundProduct.taxes);
                            foundProduct.unitPrice = getUnitPrice(foundProduct.taxes, foundProduct.quantity, foundProduct.discount, discountType);
                            foundProduct.netValue = 0;
                        } else {
                            foundProduct.netValue = getNetValueByTotalValue(data.totalValue, foundProduct.vatPercentage, foundProduct.taxes);
                            foundProduct.unitPrice = getUnitPrice(foundProduct.netValue, foundProduct.quantity, foundProduct.discount, discountType);
                        }
                        userTotalValInput = data.totalValue;
                    } else {
                        foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                    }
                    if(foundProduct.isTaxLine === "true"){
                        foundProduct.vat = getVatValue(foundProduct.taxes, foundProduct.vatPercentage);
                    } else {
                        if (foundProduct._id !== productData._id) {
                            foundProduct.code = productData.code;
                            foundProduct.name = productData.name;
                            foundProduct.unitPrice = isNaN(Number(productData.price)) ? 0 : productData.price;
                            foundProduct.measurementUnit = productData.measurementUnit;
                            foundProduct.netValue = (Number(foundProduct.quantity) * Number(foundProduct.unitPrice)).toFixed(2);
                            foundProduct.vatPercentage = !isNaN(productData.vat) ? productData.vat : 0;
                            foundProduct.totalValue = productData.vatIncluded === "true" ? getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes, foundProduct.vat) : getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                        }
                        foundProduct.vat = getVatValue(foundProduct.netValue, foundProduct.vatPercentage, userTotalValInput);
                    }
                    if(productData?.isTaxLine === "true"){
                        if(!quickEdit) foundProduct.vatPercentage  = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                        if(!quickEdit) {
                            if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(foundProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
                            } else if (clientVatCategory === "Zero VAT") {
                                foundProduct.vatId = "7";
                            } else {
                                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                            }
                        }
                        if(!quickEdit) foundProduct.vatReason      = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
                        foundProduct.discount       = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatType, discountType);
                        foundProduct.netValue       = 0;
                        foundProduct.withHoldTax    = productData.withholdTax;
                        foundProduct.otherTax       = productData.otherTaxes;
                        foundProduct.fee           = productData.fee;
                        foundProduct.stamp           = productData.stamp;
                        foundProduct._id            = productData._id;
                        foundProduct.isTaxLine      = productData.isTaxLine;
                        foundProduct.classificationCategory = '';
                        foundProduct.classificationType = '';
                        foundProduct.vatExpenseType = '';
                        foundProduct.isTaxLineWithoutVat      = productData.isTaxLineWithoutVat;
                        foundProduct.taxes          = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                        foundProduct.otherTaxEuro   = getProductOtherTax(foundProduct, SETTINGS);
                        foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                        foundProduct.feeEuro        = getProductFee(foundProduct, SETTINGS);
                        foundProduct.stampEuro      = getProductStamp(foundProduct, SETTINGS);
                        foundProduct.vat            = getVatValue(foundProduct.taxes, foundProduct.vatPercentage);
                        foundProduct.totalValue     = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                    } else {
                        if(!quickEdit) foundProduct.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                        if(!quickEdit) {
                            if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(foundProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
                            } else if (clientVatCategory === "Zero VAT") {
                                foundProduct.vatId = "7";
                            } else {
                                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                            }
                        }
                        if(!quickEdit) foundProduct.vatReason = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
                        foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatIncluded, discountType);
                        foundProduct.withHoldTax = productData.withholdTax;
                        foundProduct.otherTax = productData.otherTaxes;
                        foundProduct.fee = productData.fee;
                        foundProduct.stamp = productData.stamp;
                        foundProduct._id = productData._id;
                        foundProduct.classificationCategory = '';
                        foundProduct.classificationType = '';
                        foundProduct.vatExpenseType = '';
                        foundProduct.taxes = getTaxes(foundProduct, SETTINGS);
                        foundProduct.otherTaxEuro = getProductOtherTax(foundProduct, SETTINGS);
                        foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                        foundProduct.feeEuro = getProductFee(foundProduct, SETTINGS);
                        foundProduct.stampEuro        = getProductStamp(foundProduct, SETTINGS);
                        if (isEmpty(data.vat)) foundProduct.vat = getVatValue(foundProduct.netValue, foundProduct.vatPercentage, userTotalValInput);
                        foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes, foundProduct.vat);
                    }
                    const updatedPmProducts = { ...plProducts[foundProduct.no - 1], ...foundProduct }
                    let productQuotationsTaxes;

                    plProducts[foundProduct.no - 1] = updatedPmProducts;

                    let productTotals = getSalesTotals(plProducts, SETTINGS);
                    productQuotationsTaxes = getSalesTaxesData(plProducts, currentQuotationsState.extraData, productTotals, SETTINGS);

                    let totalTaxes = 0;
                    let withHoldTaxes = 0;
                    let deductions = 0;
                    if(productQuotationsTaxes.length > 0 && productQuotationsTaxes[0].vatPercentage === "Invoice Level Tax"){
                        totalTaxes = parseFloat( (Number(productQuotationsTaxes[0].otherTaxes) + Number(productQuotationsTaxes[0].fees) + Number(productQuotationsTaxes[0].stamp)).toString());
                        withHoldTaxes = parseFloat(productQuotationsTaxes[0].withholdTaxes).toFixed(2);
                        deductions = parseFloat(productQuotationsTaxes[0].deductions).toFixed(2);
                    }
                    if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
                        productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
                        productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
                    }

                    if(currentState) {
                        setRefreshPage(refreshPage + 1);
                        setProductTableSpinner('false');
                        return { ...currentQuotationsState, products: plProducts, salesTaxes: productQuotationsTaxes, ...productTotals };
                    } else {
                        dispatch(setEditQuotations({ ...currentQuotationsState, products: plProducts, salesTaxes: productQuotationsTaxes, ...productTotals }));
                    }
                    setRefreshPage(refreshPage + 1);
                    setProductTableSpinner('false');
                }
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!ACTIVITY.saveEditQuotations) dispatch(setSaveEditQuotations(true));

            let cloneProducts = structuredClone(editQuotations.products);
            cloneProducts.splice(rowIndex, 1);
            cloneProducts.forEach((prod, idx) => {
                prod.no = idx + 1;
                prod.id = String(idx + 1);
            })
            dispatch(setEditQuotations({...editQuotations, products: cloneProducts}));
            setUpdateSaleAmounts(true);
        }
    }

    const selectedDocumentType = getDefaultOptionByValue(documentTypesOptions, editQuotations.documentType, 'value', 'label', 'value');

    let tableWrClasses = "product-form sales-products-list position-relative";

    if (editQuotations.client !== '') {
        tableWrClasses += " normalIndex";
    }

    const [incrKey, setIncrKey] = useState(0);
    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editQuotations.products, quotationsProductList])

    const [incrKey2, setIncrKey2] = useState(0);
    useEffect(() => {
        setIncrKey2(incrKey2 + 1);
    }, [editQuotations.products, quotationsProductList, editQuotations.extraData])

    const editQuotationsTab = [
        {
            tabName: t('SalesNew.productTable.title'),
            tabData: (
                <React.Fragment>
                    <Row className={tableWrClasses}>
                        <Col md={12}>
                            {(editQuotations.client === '' && editQuotations.newClient === '') && <div className="overlay_w">{t('SalesNew.message2')}</div>}
                            {showProductTableSpinner && showProductTableSpinner === 'true' && <div className="overlay_w"> <div className="spinner-border" role="status"> <span className="sr-only">{t("SalesNew.loading")}</span> </div> </div>}
                            {editQuotations?.products && editQuotations?.products?.length === 0 && <span className="text-danger">{t('SalesNew.messageProductList')}</span>}
                            <EditableTable
                                tableName="Quotations Products List Edit"
                                key={"Quotations Products List Edit" + incrKey}
                                actionButtons={{
                                    print: false,
                                    delete: true,
                                    export: false,
                                    edit: true,
                                }}
                                columns={clientProductsColumns}
                                data={editQuotations.products}
                                allowInsertRow={true}
                                onUpdate={quotationsProductListActions}
                                allowActions={true}
                                allowToggleColumns={false}
                                allowPrintResults={false}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className={"d-flex justify-content-end"}>
                            {editQuotations?.discountAsLine === true && (
                                <div className={"mt-1 mr-3 text-muted"}>(*) Η έκπτωση θα προβληθεί ως γραμμή παραστατικού με περιγραφή: {editQuotations?.discountAsLineText}</div>
                            )}
                            <Button size={"sm"} onClick={() => setShowDiscountModal(true)}>Εφαρμογή Έκπτωσης</Button>
                        </Col>
                    </Row>
                </React.Fragment>
            ),
        },
    ];

    let quickEditClientData = {};
    if (editQuotations.clientType === 'Existing') {
        if (editQuotations.client && editQuotations.client !== "") {
            quickEditClientData.name = editQuotations.clientName;
            quickEditClientData.id = editQuotations.client;
            quickEditClientData.vatCategory = editQuotations.vatCategory;
            quickEditClientData.address = editQuotations.address;
            quickEditClientData.vatNumber = editQuotations.vat;
            quickEditClientData.doy = getLabelByValue(getDOYOptions(), Number(editQuotations.doy), 'value');
            quickEditClientData.city = editQuotations.city;
            quickEditClientData.amka = editQuotations?.amka;
            quickEditClientData.clientCategoryName = editQuotations?.clientCategoryName;
            quickEditClientData.clientCategory = editQuotations?.clientCategory;
            quickEditClientData.pc = editQuotations.pc;
            quickEditClientData.email = editQuotations.email;
            quickEditClientData.phone = editQuotations.phone;
        }
    }

    const quickEditClient = (e, type, data) => {
        let selectedClient = editQuotations.client;
        if (selectedClient) {
            let quickClientData = {};
            quickClientData._id = editQuotations.client;
            quickClientData.company = company.id;
            quickClientData.name = data.name;
            quickClientData.vatCategory = data.vatCategory;
            quickClientData.vatNumber = data.vatNumber;
            quickClientData.address = data.address;
            quickClientData.city = data.city;
            quickClientData.amka = data?.amka;
            quickClientData.categoryName = data?.clientCategoryName;
            quickClientData.category = data?.clientCategory;
            quickClientData.email = data.email;
            quickClientData.phone = data.phone;

            if (((data.email !== '' || data.phone !== '') && data.clientCategoryName !== "Patient") || (data.clientCategoryName === "Patient" && !isEmpty(data?.amka) && data.name !== '' && data.vatCategory !== '')) {
                dispatch(putClient(quickClientData, requestData));
                let sClient = data;
                let repopulateClient = {};
                repopulateClient.clientCategoryName = sClient?.clientCategoryName;
                repopulateClient.clientCategory = sClient?.clientCategory;
                repopulateClient.clientName = sClient.name;
                repopulateClient.address = sClient.address;
                repopulateClient.vat = sClient.vatNumber;
                repopulateClient.vatCategory = sClient.vatCategory;
                repopulateClient.city = sClient.city;
                repopulateClient.amka = sClient?.amka;
                repopulateClient.email = sClient.email;
                repopulateClient.pc = sClient.postalCode;
                repopulateClient.phone = sClient.phone;

                dispatch(setEditQuotations({ ...editQuotations, ...repopulateClient }));

            } else {
                toast.error('Name, Email or Phone and Vat Category required fields.');
            }
        }
    }

    const clearClient = () => {
        if(editQuotations.client !== ''){
            let editQuotationsData = {};
            editQuotationsData.client = "";
            editQuotationsData.clientName = "";
            editQuotationsData.clientCode = "";
            editQuotationsData.address = "";
            editQuotationsData.vat = "";
            editQuotationsData.doy = "";
            editQuotationsData.city = "";
            editQuotationsData.amka = "";
            editQuotationsData.clientCategoryName = "";
            editQuotationsData.clientCategory = "";
            editQuotationsData.country = "";
            editQuotationsData.pc = "";
            editQuotationsData.email = "";
            editQuotationsData.phone = "";
            editQuotationsData.activity = "";
            editQuotationsData.vatCategory = "";
            setClientInstallationListData(CLIENTS_DATA.installations.slice());
            editQuotationsData.clientInstallationType = "";
            editQuotationsData.clientInstallationId = "";

            dispatch(setEditQuotations({ ...editQuotations, ...editQuotationsData }));
        }
    }

    let quotationsTaxesColumns = [
        {
            name: t('SalesNew.salesTaxesTables.vat%'),
            field: "vatPercentage",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.netValue'),
            field: "netValue",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.vat'),
            field: "vatEuro",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.withHoldTaxes'),
            field: "withholdTaxes",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.otherTaxes'),
            field: "otherTaxes",
            width: "10%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.fees'),
            field: "fees",
            width: "10%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.stampDuty'),
            field: "stamp",
            width: "10%",
            editable: false,
        },
        {
            name: "Κρατήσεις",
            field: "deductions",
            width: "10%",
            editable: false,
        }
    ];
    let totalTaxes = 0;
    let withHoldTaxes = 0;
    let deductions = 0;
    let productTotals = useMemo(() => getSalesTotals(editQuotations.products, SETTINGS), [editQuotations.products]);
    let salesTaxesData = useMemo(() => getSalesTaxesData(editQuotations.products, editQuotations.extraData || {}, productTotals, SETTINGS), [editQuotations.products, editQuotations.extraData, productTotals, SETTINGS]);
    if(salesTaxesData.length > 0 && salesTaxesData[0].vatPercentage === "Invoice Level Tax"){
        totalTaxes = parseFloat( (Number(salesTaxesData[0].otherTaxes) + Number(salesTaxesData[0].fees) + Number(salesTaxesData[0].stamp)).toString());
        withHoldTaxes = parseFloat(salesTaxesData[0].withholdTaxes).toFixed(2);
        deductions = parseFloat(salesTaxesData[0].deductions).toFixed(2);
    }

    let totalQuantity = productTotals.totalQuantity;
    let totalBeforeDiscount = productTotals.totalBeforeDiscount;
    let totalDiscount = productTotals.totalDiscount;
    let totalNetValue = productTotals.totalNetValue;
    let totalAmount = productTotals.totalAmount;
    let totalVatAmount = productTotals.totalVatValue;

    withHoldTaxes = parseFloat(parseFloat(productTotals.withHoldTaxes) + parseFloat(withHoldTaxes));
    if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
        totalAmount = parseFloat(totalAmount) + parseFloat(totalTaxes);
    }
    totalTaxes += Number(productTotals.totalTaxesAmount);
    const selectDocumentInstallation = getDefaultOptionByValue(dtInstallationsOptions, editQuotations.installation, 'value', 'label', 'value');
    const selectPreNumber = getDefaultOptionByValue(preNumberGreekOptions, editQuotations.preNumber, 'value', 'label', 'value');

    useEffect(() => {
        if(updateSaleAmounts === true) {
            setUpdateSaleAmounts(false);
            let extraData = {};
            if(salesTaxesData.length > 0) {
                salesTaxesData.forEach((salesTax) => {
                    if(salesTax.vatPercentage === "Invoice Level Tax") {
                        extraData.witholdTaxEuro = salesTax.withholdTaxes;
                        extraData.otherTaxEuro = salesTax.otherTaxes;
                        extraData.feeEuro = salesTax.fees;
                        extraData.stampEuro = salesTax.stamp;
                    }
                })
            }

            dispatch(setEditQuotations({
                ...editQuotations,
                salesTaxes: salesTaxesData,
                extraData: {...editQuotations.extraData, ...extraData},
                withHoldTaxes: withHoldTaxes.toFixed(2),
                ...productTotals,
            }))
        }
    }, [updateSaleAmounts]);

    const discountObj = useSelector((state) => state.SALES.quotationDiscountObject);
    const discountTypeOptions = [
        {label: "Ποσοστιαία %", value: "percentage"},
        {label: "Ποσό €", value: "amount"}
    ]
    const handleOnDiscountChange = (e, type, name) => {
        if (type === "dropdown") {
            dispatch(setQuotationDiscountObject({...discountObj, [name] : e.value, amount: 0}));
        } else if (type === "input") {
            dispatch(setQuotationDiscountObject({...discountObj, [name] : e.target.value}));
        } else if (type === "cb") {
            dispatch(setQuotationDiscountObject({...discountObj, [name] : e.target.checked}));
        }
    }
    const handleSaveDiscount = () => {
        if (!+editQuotations.totalNetValue > 0) return toast.error("Παρακαλώ συμπληρώστε πρώτα τις τιμές.");
        if (isNaN(discountObj.amount)) return toast.error(`Το ${discountObj.discountType === "percentage" ? "ποσοστό" : "ποσό"} δεν είναι δεκτός αριθμός.`);
        if (discountObj.discountAsLine === true && isEmpty(discountObj.discountAsLineText)) return toast.error("Παρακαλώ συμπληρώστε την περιγραφή της έκπτωσης.");

        let toApplyAmount = 0;
        if (discountObj.discountType === "percentage") {
            toApplyAmount = +Number((discountObj.amount / 100) * +editQuotations.totalNetValue).toFixed(2);
        } else if (discountObj.discountType === "amount") {
            toApplyAmount = +Number(discountObj.amount * (+editQuotations.totalNetValue / (+editQuotations.totalNetValue + +editQuotations.totalVatValue))).toFixed(2);
        }
        let clonedProducts = structuredClone(editQuotations.products);
        for (let prod of clonedProducts) {
            if (prod?.isTaxLine !== "true") {
                const ratio = (+prod.unitPrice * +prod.quantity) / (+editQuotations.totalNetValue + +editQuotations.totalDiscount);
                const discountAmount = +Number(ratio * toApplyAmount).toFixed(2);
                prod.isPerDiscount = "false";
                prod.isDiscountAmount = "true";
                prod.discount = discountAmount;
                prod.netValue = getNetValue(prod.unitPrice, prod.quantity, prod.discount);
                prod.taxes = getTaxes(prod, SETTINGS);
                prod.otherTaxEuro = getProductOtherTax(prod, SETTINGS);
                prod.witholdTaxEuro = getProductWithholdTax(prod, SETTINGS);
                prod.feeEuro = getProductFee(prod, SETTINGS);
                prod.stampEuro = getProductStamp(prod, SETTINGS);
                prod.vat = getVatValue(prod.netValue, prod.vatPercentage);
                prod.totalValue = getTotalValue(prod.netValue, prod.vatPercentage, prod.taxes);
            }
        }

        let productTotals = getSalesTotals(clonedProducts, SETTINGS);
        const extraDataForCalc = editQuotations.extraData || editQuotations;
        let productQuotationsTaxes = getSalesTaxesData(clonedProducts, extraDataForCalc, productTotals, SETTINGS);

        let totalTaxes = 0;
        let withHoldTaxes = 0;
        let deductions = 0;

        if(productQuotationsTaxes.length > 0 && productQuotationsTaxes[0].vatPercentage === "Invoice Level Tax"){
            totalTaxes = parseFloat( (Number(productQuotationsTaxes[0].otherTaxes) + Number(productQuotationsTaxes[0].fees) + Number(productQuotationsTaxes[0].stamp)).toString());
            withHoldTaxes = parseFloat(productQuotationsTaxes[0].withholdTaxes).toFixed(2);
            deductions = parseFloat(productQuotationsTaxes[0].deductions).toFixed(2);
        }

        if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
            productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
            productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
        }

        let prepSaleObj = {
            ...editQuotations,
            products: clonedProducts,
            salesTaxes: productQuotationsTaxes,
            ...productTotals
        }

        prepSaleObj.discountAsLine = discountObj.discountAsLine;
        prepSaleObj.discountAsLineText = discountObj.discountAsLineText;

        dispatch(setEditQuotations(prepSaleObj));
        setShowDiscountModal(false);
        toast.success("Η έκπτωση εφαρμόστηκε επιτυχώς", {autoClose: 2000});
    }

    const hookNewClientInSale = (newClientData) => {
        if (newClientData) {
            const clientBasicData = {
                clientName: newClientData.name,
                client: newClientData._id,
                clientCode: newClientData.systemCode,
                clientType: 'Existing',
                address: newClientData.address,
                vat: newClientData.vatNumber,
                doy: getDOYOptions().find((el) => String(el.value) === String(newClientData.DOY))?.label,
                city: newClientData.city,
                amka: newClientData?.amka,
                clientCategoryName: newClientData.categoryName,
                clientCategory: newClientData.category,
                pc: newClientData.postalCode,
                country: newClientData.country,
                clientInstallationId: "0",
                clientInstallationType: "1",
                email: newClientData.email,
                phone: newClientData.phone,
                activity: newClientData.activity
            }
            newClientData.installations.map(installation => {
                installation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
                return installation;
            })
            clientBasicData.clientInstallationType = newClientData.installations[0]?.type;
            clientBasicData.clientInstallationId = newClientData.installations[0]?.no;

            const editQuotationsData = {...editQuotations, ...clientBasicData}

            dispatch(setEditQuotations(editQuotationsData));
        }
    }

    return (
        <div className="new-sales">
            <div className="client-form product-form position-relative">
                {disabledFields && <div className="overlay_w">{t('SalesNew.message')}</div>}
                <Row className="border-bottom mb-2">
                    <Col sm={12} md={4} className="showWithOverlay">
                        <Dropdown
                            label={t('SalesNew.DocumentType')}
                            key={selectedDocumentType.value}
                            defaultValue={selectedDocumentType}
                            required={true}
                            searchEnable={true}
                            name="documentType"
                            options={documentTypesOptions}
                            onChange={(e) => handleOnChange(e, 'dd', 'documentType')}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md="3">
                        <DateBox
                            classes="w-100 mb-2"
                            label={t('SalesNew.Date')}
                            name="date"
                            selected={
                                editQuotations.date && !isNaN(new Date(editQuotations.date).getTime())
                                    ? new Date(editQuotations.date)
                                    : new Date()
                            }
                            onChange={(e) => handleOnChange(e, 'dp', 'date')}
                        />
                    </Col>
                    <Col sm="12" md="1">
                        <HourPicker
                            label={t('SalesNew.time')}
                            selected={
                                editQuotations.time && moment(editQuotations.time, "HH:mm").isValid()
                                    ? moment(editQuotations.time, "HH:mm").toDate()
                                    : new Date()
                            }
                            onChange={(e) => handleOnChange(e, "tp", "time")}
                        />
                    </Col>
                    <Col sm="12" md="8" className="text-right d-flex align-items-center justify-content-end">
                        {printLayout === "sales-print-a5-greek" && (
                            <SendEmail className="view-sales-buttons" clientId={editQuotations.client}
                                       modalContent="Do you want to send quotation mail to the client?"
                                       mailTo={editQuotations.email} mailSubject="Your Quotation"
                                       mailContent="Here is your quotation" documentType="quotation"
                                       documentId={editQuotations._id} pdf={componentRefA5.current}/>)}
                        {printLayout === "sales-print-a5-english" && (
                            <SendEmail className="view-sales-buttons" clientId={editQuotations.client}
                                       modalContent="Do you want to send quotation mail to the client?"
                                       mailTo={editQuotations.email} mailSubject="Your Quotation"
                                       mailContent="Here is your quotation" documentType="quotation"
                                       documentId={editQuotations._id} pdf={componentRefA5En.current}/>)}
                        {printLayout === "sales-print-a5-double-greek" && (
                            <SendEmail className="view-sales-buttons" clientId={editQuotations.client}
                                       modalContent="Do you want to send quotation mail to the client?"
                                       mailTo={editQuotations.email} mailSubject="Your Quotation"
                                       mailContent="Here is your quotation" documentType="quotation"
                                       documentId={editQuotations._id} pdf={componentRefDA5.current}/>)}
                        {printLayout === "sales-print-a5-double-english" && (
                            <SendEmail className="view-sales-buttons" clientId={editQuotations.client}
                                       modalContent="Do you want to send quotation mail to the client?"
                                       mailTo={editQuotations.email} mailSubject="Your Quotation"
                                       mailContent="Here is your quotation" documentType="quotation"
                                       documentId={editQuotations._id} pdf={componentRefDA5En.current}/>)}
                        {(printLayout === "sales-print-template1-greek" || !printLayout) && (
                            <SendEmail className="view-sales-buttons" clientId={editQuotations.client}
                                       modalContent="Do you want to send quotation mail to the client?"
                                       mailTo={editQuotations.email} mailSubject="Your Quotation"
                                       mailContent="Here is your quotation" documentType="quotation"
                                       documentId={editQuotations._id} pdf={componentRef.current}/>)}
                        {printLayout === "sales-print-template1-english" && (
                            <SendEmail className="view-sales-buttons" clientId={editQuotations.client}
                                       modalContent="Do you want to send quotation mail to the client?"
                                       mailTo={editQuotations.email} mailSubject="Your Quotation"
                                       mailContent="Here is your quotation" documentType="quotation"
                                       documentId={editQuotations._id} pdf={componentRefEn.current}/>)}
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col sm="12" md="4">
                        <Dropdown
                            className={"mb-0"}
                            label={t('SalesNew.installation')}
                            options={dtInstallationsOptions}
                            value={Object.keys(selectDocumentInstallation).length !== 0 ? selectDocumentInstallation : ''}
                            enabledValue={true}
                            searchEnable={true}
                            required={true}
                            name="installation"
                            onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                            disabled={String(editQuotations?.corelatedDocument).length === 24}
                        />
                    </Col>
                    <Col sm="12" md="4">
                        <Dropdown
                            className={"mb-0"}
                            label={t('SalesNew.preNumber.preNumber')}
                            name="preNumber"
                            required={true}
                            key={Math.random()}
                            defaultValue={Object.keys(selectPreNumber).length !== 0 ? selectPreNumber : ''}
                            options={preNumberGreekOptions}
                            disabled={editQuotations.numberingMode === 'manual'}
                            onChange={(e) => handleOnChange(e, 'dd', 'preNumber')}
                        />
                        {ACTIVITY.saveEditQuotations  && editQuotations.preNumber === "" && <div className="text-danger">{t('SalesNew.preNumber.required')}</div>}
                    </Col>
                    <Col sm="12" md="4">
                        <Input
                            label={t('SalesNew.number.number')}
                            name="number"
                            required={true}
                            value={editQuotations.number}
                            placeholder={t('SalesNew.number.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                            disabled={editQuotations.numberingMode !== 'manual'}
                            autoComplete={"off"}
                        />
                        {ACTIVITY.saveEditQuotations  && editQuotations.number === "" && <div className="text-danger">{t('SalesNew.number.required')}</div>}
                    </Col>
                </Row>
                <Row>
                    {editQuotations.clientType === 'Existing' &&
                        <Col md="5" className={"mb-2"}>
                            <AdvancedCombobox
                                ACName="Quotations" // do not change name
                                className="w-200 ac-select-dropdown"
                                key={editQuotations.clientName}
                                defaultValue={editQuotations.clientName}
                                label={t('SalesNew.client.client')}
                                data={clientsListData}
                                onChangeSearch={onChangeSearch}
                                onChange={(e) => handleOnChange(e, 'acdd', 'client')}
                                excludeColumns={[]}
                                columns={clientDropdownColumns}
                                deleteEnable={false}
                                searchTableEnable={false}
                                showTableOptionOnSelect={true}
                                placeholder={t('SalesNew.client.placeholder')}
                                required={true}
                                showInsertAddButton={true}
                                hideSaveButton={true}
                                hideInsertNewRow={true}
                                inputFieldClasses="form-control"
                                disabled={false}
                            />
                            {ACTIVITY.saveEditQuotations && editQuotations.clientType === 'New' && editQuotations.newClient === "" && <div className="text-danger">{t('SalesNew.client.required')}</div>}
                            {ACTIVITY.saveEditQuotations && editQuotations.clientType === 'Existing' && editQuotations.client === "" && <div className="text-danger">{t('SalesNew.client.required')}</div>}
                        </Col>
                    }
                    {editQuotations.clientType === 'New' &&
                        <Col md="5" className={"mb-2"}>
                            <Input
                                className="w-100 newclient-field"
                                label={t('SalesNew.newRetailClient.newRetailClient')}
                                name="newClient"
                                autoComplete={"off"}
                                value={editQuotations.newClient}
                                placeholder={t('SalesNew.newRetailClient.placeholder')}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    }
                    {String(editQuotations?.corelatedDocument).length === 24 ? (
                        <Col md={1}></Col>
                    ) : (
                        <Col sm="1" md="1">
                            <div className="d-flex  mt-4">
                                <div className="quick-client-actions">
                                    {editQuotations.client !== '' && editQuotations.clientType === 'Existing' && <QuickEdit title="Edit selected client." columns={quickClientFields} data={quickEditClientData} hideCurrentValue={true} updateData={quickEditClient} />}
                                    {editQuotations.client !== '' && editQuotations.clientType === 'Existing' && <button className="btn quick-retail-clientbtn btn-default btn-sm" title="Clear Client Fields" onClick={clearClient}><i className="fas fa-xmark"></i></button>}
                                    {((editQuotations.client === '' && editQuotations.newClient === '') || editQuotations.clientType !== 'Existing') && <NewClientModal myDataType={editQuotations.myDataType} successCallback={(data) => hookNewClientInSale(data)} />}
                                </div>
                            </div>
                        </Col>
                    )}
                    {(editQuotations.clientType === 'Existing' && isEmpty(editQuotations.amka)) && (
                        <Col sm="12" md="2">
                            <div className="d-flex">
                                <AdvancedCombobox
                                    ACName="Client Installation" // do not change name
                                    className="w-100 ac-select-dropdown"
                                    defaultValue={editQuotations.clientInstallationType}
                                    label={t('SalesNew.clientInstallation.clientInstallation')}
                                    data={clientInstallationListData}
                                    onChangeSearch = {onChangeSearch}
                                    onChange={(e) => handleOnChange(e, 'acdd', 'clientInstallation')}
                                    excludeColumns={[]}
                                    columns={clientInstallationsDropdownColumns}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    placeholder={t('SalesNew.clientInstallation.placeholder')}
                                    required={true}
                                    showInsertAddButton={true}
                                    hideSaveButton={true}
                                    hideInsertNewRow={true}
                                    inputFieldClasses="form-control"
                                    disabled={String(editQuotations?.corelatedDocument).length === 24}
                                />
                            </div>
                        </Col>
                    )}
                    {(editQuotations.clientType === 'Existing' && !isEmpty(editQuotations.amka)) && (
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={"ΑΜΚΑ Ασθενή"}
                                name="amka"
                                autoComplete={"off"}
                                value={editQuotations.amka}
                                onChange={(e) => handleOnChange(e)}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {editQuotations.clientType === 'Existing' && (
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={t('SalesNew.vat')}
                                name="vat"
                                autoComplete={"off"}
                                value={editQuotations.vat}
                                onChange={(e) => handleOnChange(e)}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {editQuotations.clientType === 'Existing' && (
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={t('SalesNew.doy')}
                                name="doy"
                                autoComplete={"off"}
                                value={editQuotations.doy}
                                onChange={(e) => handleOnChange(e)}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {/* Show if new client */}
                    {editQuotations.clientType === 'New' &&
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={t('SalesNew.email.email')}
                                name="email"
                                autoComplete={"off"}
                                required={editQuotations.clientType === 'New' && editQuotations.phone === ''}
                                value={editQuotations.email}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {ACTIVITY.saveEditQuotations && editQuotations.clientType === 'New' && editQuotations.email === "" && editQuotations.phone === "" && <div className="text-danger">{t('SalesNew.email.required')}</div>}
                        </Col>
                    }
                    {/* Show if new client */}
                    {editQuotations.clientType === 'New' &&
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={t('SalesNew.phone.phone')}
                                name="phone"
                                autoComplete={"off"}
                                required={editQuotations.clientType === 'New' && editQuotations.email === ''}
                                value={editQuotations.phone}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    }
                </Row>
                <Row>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('SalesNew.city')}
                            name="city"
                            autoComplete={"off"}
                            value={editQuotations.city}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('SalesNew.address')}
                            name="address"
                            autoComplete={"off"}
                            value={editQuotations.address}
                            disabled={String(editQuotations?.corelatedDocument).length === 24}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t("General.postalCode")}
                            name="pc"
                            autoComplete={"off"}
                            value={editQuotations.pc}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                    <Col md={6} className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('General.activity')}
                            name="activity"
                            autoComplete={"off"}
                            value={editQuotations.activity}
                            onChange={(e) => handleOnChange(e)}
                            disabled={editQuotations.clientType !== 'New'}
                            readonly
                        />
                    </Col>
                </Row>
                <Row>
                    {editQuotations.salePurpose === "19" && (
                        <Col md={4}>
                            <Input
                                name={"salePurposeName"}
                                label={"Περιγραφή σκοπού διακίνησης"}
                                required={true}
                                autoComplete={"off"}
                                value={editQuotations.salePurposeName ? editQuotations.salePurposeName : ""}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    )}
                </Row>
                <Row>
                    <Col md="12" className="mb-2">
                        <ul className="react-tabs__tab-list tab-style tab-min component-subtabs">
                            {(() => {
                                const tabs = [...editQuotationsTab];

                                return tabs.map((tab, i) => (
                                    <li key={i} className="react-tabs__tab">
                                        <button type="button" onClick={() => setActiveTab(i)} className={`customNavBtn ${activeTab === i && "btnActive"}`}>
                                            <span className="textWrapper">{tab.tabName}</span>
                                        </button>
                                    </li>
                                ));
                            })()}
                        </ul>
                        {(() => {
                            const tabs = [...editQuotationsTab];

                            return <div className="innerTabPanel">{tabs[activeTab]?.tabData}</div>;
                        })()}
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md="8" style={{position: "inherit"}}>
                        <EditableTable
                            tableName={"Quotations Edit Taxes Calculations"}
                            className="sales-taxes-calculations"
                            allowActions={false}
                            key={incrKey2}
                            data={fixDocumentTaxesDisplay({...editQuotations, salesTaxes: salesTaxesData}, "sales")}
                            columns={quotationsTaxesColumns}
                            actionButtons={{
                                print: false,
                                delete: false,
                                export: false,
                                edit: false,
                            }}
                        />
                    </Col>
                    <Col sm="12" md="4" className="d-flex justify-content-end">
                        <span className="mr-3 fw-bold">{t('SalesNew.totalsTable.title')}</span>
                        <table className="table table-bordered mb-2">
                            <tbody>
                            <tr><td className="fw-bold">{"Συνολική Ποσότητα"}</td><td>{totalQuantity}</td></tr>
                            <tr><td className="fw-bold">{"Σύνολο πριν από την Έκπτωση"}</td><td>{getGreekCurrencyFormat(totalBeforeDiscount)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολική Έκπτωση"}</td><td>{getGreekCurrencyFormat(totalDiscount)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολική Καθαρή Αξία"}</td><td>{getGreekCurrencyFormat(totalNetValue)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολικό Ποσό Φ.Π.Α."}</td><td>{getGreekCurrencyFormat(totalVatAmount)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολικό Ποσό Παρακρατούμενων Φόρων"}</td><td>{getGreekCurrencyFormat(withHoldTaxes)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολικό Ποσό Φόρων"}</td><td>{getGreekCurrencyFormat(totalTaxes)}</td></tr>
                            <tr><td className="fw-bold">{"Συνολικό ποσό"}</td><td>{getGreekCurrencyFormat(totalAmount)}</td></tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <div style={{width: "100%"}}>
                            <div className="text-muted mb-2"><i>{"Σημειώσεις Προσφοράς"}</i></div>
                            <TextArea
                                rows="4"
                                placeholder={t('SalesNew.addNotes')}
                                name="notes"
                                value={editQuotations.notes}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            {/* Confirm Category Change */}
            <Modal backdrop={"static"} className="themeModal" show={showCategoryConfirmation} onHide={() => setshowCategoryConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('SalesNew.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('SalesNew.warningMessage')}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setshowCategoryConfirmation(false)}>{t('SalesNew.no')}</Button>
                    <Button variant="primary" onClick={() => handleConfirmCategory()} >{t('SalesNew.yes')}</Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={showDiscountModal} onHide={() => setShowDiscountModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Εφαρμογή Έκπτωσης</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Dropdown
                                name={"discountType"}
                                label={"Τύπος Έκπτωσης"}
                                options={discountTypeOptions}
                                key={Math.random()}
                                defaultValue={discountTypeOptions.find((el) => el.value === discountObj.discountType)}
                                onChange={(e) => handleOnDiscountChange(e, "dropdown", "discountType")}
                            />
                        </Col>
                        <Col md={12}>
                            <Input
                                name={"amount"}
                                label={discountObj.discountType === "percentage" ? "Ποσοστό %" : "Ποσό €"}
                                value={discountObj.amount}
                                type={"number"}
                                autoComplete={"off"}
                                onChange={(e) => handleOnDiscountChange(e, "input", "amount")}
                            />
                        </Col>
                        <Col md={12}>
                            <BetterCheckBox
                                name={"discountAsLine"}
                                text={"Προβολή έκπτωσης ως γραμμή παραστατικού"}
                                checked={discountObj.discountAsLine}
                                className={"mt-3"}
                                onChange={(e) => handleOnDiscountChange(e, "cb", "discountAsLine")}
                            />
                        </Col>
                        {discountObj.discountAsLine === true && (
                            <Col md={12}>
                                <Input
                                    name={"discountAsLineText"}
                                    label={"Περιγραφή έκπτωσης"}
                                    required={true}
                                    value={discountObj.discountAsLineText}
                                    onChange={(e) => handleOnDiscountChange(e, "input", "discountAsLineText")}
                                />
                            </Col>
                        )}
                        <Col md={12} className={"mt-3"}>
                            <Alert variant={"secondary"}>Κατά την αποθήκευση οι προϋπάρχουσες εκπτώσεις θα αντικατασταθούν με τις καινούργιες.</Alert>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowDiscountModal(false)}>Κλείσιμο</Button>
                    <Button variant="primary" onClick={() => handleSaveDiscount()}>Εφαρμογή Έκπτωσης</Button>
                </Modal.Footer>
            </Modal>

            <SalesPrintA5Greek ref={componentRefA5} data={printTemplateData}/>
            <SalesPrintA5English ref={componentRefA5En} data={printTemplateData}/>
            <SalesPrintA5DoubleGreek ref={componentRefDA5} data={printTemplateData}/>
            <SalesPrintA5DoubleEnglish ref={componentRefDA5En} data={printTemplateData}/>
            <SalesPrintTemplateGreek1 ref={componentRef} data={printTemplateData}/>
            <SalesPrintTemplateEnglish1 ref={componentRefEn} data={printTemplateData}/>
        </div>
    )
}

export const QuotationsEditLog = ({tabKey = "0"}) => {
    const {t} = useTranslation();
    const editQuotations = useSelector((state) => state.SALES.editQuotations[tabKey]);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.quotationLog')}</i></div>
            <LogTable itemId={editQuotations._id}/>
        </React.Fragment>
    )
}

export default QuotationsEdit;